import { Controller } from 'react-hook-form';
import { ToggleInput, InputText } from '@ui/src';
import { CurrencyFormTypes } from './types';

import cn from './currencies.module.css';

const CurrencyForm = ({
  control,
  errors,
  currencyId,
  setPopupVisible,
  toggleActive,
  toggleBaseCurrenyAction,
  isBaseCurrency,
  setIsBaseCurrency,
  shouldCreateBalanceForClients,
  shouldCreateBalanceForClientsError,
  toggleDefaultCreation,
  defaultCreationInProgress,
  isEditable,
}: CurrencyFormTypes) => (
  <div className={cn.currencyForm}>
    <div className={cn.currencyFormGroup}>
      <div className={cn.currencyToggleWrapper}>
        <div className={cn.currencyToggle}>
          <Controller
            control={control}
            name="active"
            render={({ field: { onChange, value, name } }) => (
              <ToggleInput
                name={name}
                title="Currency enabled"
                onChange={(e) => {
                  onChange(e.target.checked);

                  if (currencyId && toggleActive) {
                    if (!e.target.checked) {
                      setPopupVisible(true);
                    } else {
                      toggleActive(e.target.checked);
                    }
                  }
                }}
                checked={value}
              />
            )}
          />
        </div>
        <div className={cn.currencyToggle}>
          <ToggleInput
            name="baseCurrency"
            title="Base currency"
            onChange={(e) => {
              setIsBaseCurrency(e.target.checked);
              toggleBaseCurrenyAction();
            }}
            checked={isBaseCurrency}
            disabled={isBaseCurrency}
          />
        </div>
        <div className={cn.currencyToggle}>
          <ToggleInput
            name="shouldCreateBalanceForClients"
            title="Default Availability"
            onChange={(e) => toggleDefaultCreation(e.target.checked)}
            checked={shouldCreateBalanceForClients}
            disabled={defaultCreationInProgress}
          />
        </div>
      </div>
      {shouldCreateBalanceForClientsError && (
        <div className={`${cn.currencyWarning} ${cn.currencyWarningError}`}>
          {shouldCreateBalanceForClientsError}
        </div>
      )}
      <div className={cn.currencyWarning}>
        {`The currency will ${
          shouldCreateBalanceForClients ? '' : 'not'
        } be available by default when creating accounts`}
      </div>
    </div>
    <div className={cn.currencyFormGroupFlex}>
      <Controller
        control={control}
        name="code"
        render={({ field: { onChange, value, name } }) => (
          <InputText
            name={name}
            placeholder="Enter Num. code"
            onChange={onChange}
            value={value?.toString()}
            title="Numeric code"
            error={errors?.code?.message}
            labelClassName={cn.currencyFormInputLabel}
            disabled
          />
        )}
      />
      <Controller
        control={control}
        name="name"
        defaultValue=""
        render={({ field: { onChange, value, name } }) => (
          <InputText
            name={name}
            placeholder="Enter Character code"
            onChange={onChange}
            value={value}
            title="Character code"
            error={errors?.name?.message}
            labelClassName={cn.currencyFormInputLabel}
            disabled
          />
        )}
      />
    </div>
    <div className={cn.currencyFormGroup}>
      <Controller
        control={control}
        name="description"
        defaultValue=""
        render={({ field: { onChange, value, name } }) => (
          <InputText
            name={name}
            placeholder="Full name of the currency"
            onChange={onChange}
            value={value}
            title="Description"
            error={errors?.description?.message}
            disabled
          />
        )}
      />
    </div>
    <div className={cn.currencyFormGroup}>
      <Controller
        control={control}
        name="decimals"
        render={({ field: { onChange, value, name } }) => (
          <InputText
            name={name}
            title="Precesion"
            placeholder="Enter a multiplier value"
            onChange={onChange}
            value={value?.toString()}
            error={errors?.decimals?.message}
            disabled={!isEditable}
          />
        )}
      />
    </div>
  </div>
);

export default CurrencyForm;
